import React from "react";
import { Link } from "react-router-dom";
import AppShell from "../components/AppShell";
import { useAuth } from "../lib/auth";
import { useModuleActive } from "../lib/phaseFeatures";

const LABEL = { communications: "Communications", closeout: "Project Closeout" };

// modswitch: direct URLs into a standalone module (B12 communications, B13 closeout). Active -> the page; inactive ->
// "Available to Activate" with a link to the module status page (the server returns 404 module_disabled regardless).
export default function ModuleGate({ moduleKey, children }) {
  const { user } = useAuth();
  const on = useModuleActive(moduleKey, user?.id);
  if (on) return children;
  return (
    <AppShell title={LABEL[moduleKey] || "Module"}>
      <section className="mx-auto w-full max-w-[720px] px-4 py-6 space-y-3" data-testid={`module-gate-${moduleKey}`}>
        {on === null ? <p role="status" className="text-sm" data-testid="module-gate-loading">Checking status…</p> : (<>
          <p className="inline-flex rounded-sm border border-erf-borderCream bg-stone-100 px-2 py-1 text-xs font-semibold" data-testid="module-gate-state">Available to Activate</p>
          <p className="text-sm">{LABEL[moduleKey] || "This module"} is built but not activated for this workspace. The Founder can activate it on the Modules page.</p>
          <Link to={`/phase/${moduleKey}`} className="inline-flex min-h-[44px] items-center text-sm underline focus-visible:outline focus-visible:outline-2" data-testid="module-gate-status-link">View module status</Link>
        </>)}
      </section>
    </AppShell>
  );
}
